var StatesElement = {
  type: "states",
  visible: "n",
  mobile: {},
  desktop: {},
};

export default StatesElement;
